'use client';

import useChannelTalk from '@hook/useChannelTalk/useChannelTalk';
import useRecruitViewMode from '@hook/useRecruitViewMode';
import useApplyStaticFont from 'ui/hook/brand/useApplyStaticFont';

interface IProps {
  children: React.ReactNode;
}

const CommonHookContainer = ({ children }: IProps) => {
  useChannelTalk();
  useApplyStaticFont();

  const { ref } = useRecruitViewMode();

  return <div ref={ref}>{children}</div>;
};

export default CommonHookContainer;
